import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import moment from 'moment-timezone'
import PaymentReport from '../components/PaymentReport'
import SalesReport from '../components/SalesReport'
import OrderSummary from '../components/OrderSummary'
import OrderSchedule from '../components/OrderSchedule'
import OrderScheduleList from '../components/OrderScheduleList'
import ScheduleOrderList from '../components/ScheduleOrderList'
import StoreSales from '../components/StoreSales'
import StoreItemFulfilment from '../components/StoreItemFulfilment'
import ManagementPayment from '../components/ManagementPayment'
import MlbExport from '../components/MlbExport'

class PosManagementPage extends React.Component {
  _isMounted = true
  //reportDetail = StorageService.getSession('reportPage');
  comp = StorageService.getSession('selected_org')
  constructor() {
    super()
    this.state = {
      Role: this.comp.Role,
      redirect: false,
      isLoading: true,
      storeList: [],
      activeTab: '1',
      tabList: [{ name: 'Store Sales' }, { name: 'Store Item Fulfilment' }, { name: 'Payment' }],
      stateList: [],
    }
  }

  componentDidMount() {
    if (this.comp.CompanyID === 'IsKbNNvTITlL46EQuyJ7' || this.comp.CompanyID === 'QvBNN4OO2S9pml2TwlAu') {
      this.setState({
        tabList: [{ name: 'Store Sales' }, { name: 'Store Item Fulfilment' }, { name: 'Payment' }, { name: 'MLB Export' }],
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
      //this.filterOrder(this.state.orderList, tab);
      //   let data = this.posreport ? this.posreport : {};
      //   data['activeTab'] = tab;
      //   StorageService.setSession('posreport', data);
      //   this.posreport = StorageService.getSession('posreport');
    }
  }

  render() {
    const { activeTab, Role, storeList } = this.state

    return (
      <Page className="PosManagementPage" title="Management" breadcrumbs={[{ name: 'Management', active: true, path: '/posmanagement' }]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {/* <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Nav tabs className="ps-tab">
                  {this.state.tabList.map((item, index) => {
                    return (
                      <NavItem key={item.name}>
                        <NavLink
                          className={classnames({
                            active: activeTab === (index + 1).toString(),
                          })}
                          onClick={() => {
                            this.toggleTab((index + 1).toString());
                          }}
                        >
                          {item.name}
                        </NavLink>
                      </NavItem>
                    );
                  })}
                </Nav>

                <TabContent activeTab={activeTab}>
                  {this.state.storeList.length > 0 &&
                    this.state.stateList.length > 0 && (
                      <>
                        <TabPane tabId="1" className="py-3">
                          <PaymentReport data={this.state} />
                        </TabPane>
                        <TabPane tabId="2" className="py-3">
                          <SalesReport data={this.state} />
                        </TabPane>
                        <TabPane tabId="3" className="py-3">
                          <OrderSummary data={this.state} />
                        </TabPane>
                        <TabPane tabId="4" className="py-3">
                          <OrderSchedule data={this.state} />
                        </TabPane>
                        <TabPane tabId="5" className="py-3">
                          <OrderScheduleList
                            data={this.state}
                            order={this.order}
                          />
                        </TabPane>
                        <TabPane tabId="6" className="py-3">
                          <ScheduleOrderList
                            data={this.state}
                            order={this.order}
                          />
                        </TabPane>
                      </>
                    )}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row> */}
        {Role === 'Admin' && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="ps-tab">
                    {this.state.tabList.map((item, index) => {
                      return (
                        <NavItem key={item.name}>
                          <NavLink
                            className={classnames({
                              active: activeTab === (index + 1).toString(),
                            })}
                            onClick={() => {
                              this.toggleTab((index + 1).toString())
                            }}>
                            {item.name}
                          </NavLink>
                        </NavItem>
                      )
                    })}
                  </Nav>

                  <TabContent activeTab={activeTab} className="ps-tab-content">
                    <TabPane tabId="1" className="py-3">
                      <StoreSales data={this.state} />
                    </TabPane>
                    <TabPane tabId="2" className="py-3">
                      <StoreItemFulfilment data={this.state} />
                    </TabPane>
                    <TabPane tabId="3" className="py-3">
                      <ManagementPayment data={this.state} />
                    </TabPane>
                    {this.comp.CompanyID === 'IsKbNNvTITlL46EQuyJ7' || this.comp.CompanyID === 'QvBNN4OO2S9pml2TwlAu'}
                    {
                      <TabPane tabId="4" className="py-3">
                        <MlbExport data={this.state} />
                      </TabPane>
                    }
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Page>
    )
  }
}

export default PosManagementPage
